import { resolveIslandPortalContainer } from './resolve-island-portal-container.js';

/**
 * @param {Element | null | undefined} islandRootElement
 * @returns {() => HTMLElement | undefined}
 */
export function createIslandPortalContainerCallback(islandRootElement) {
	return () => resolveIslandPortalContainer(islandRootElement);
}

/**
 * @param {() => HTMLElement | undefined} getPortalContainer
 */
export function createIslandPortalThemeExtension(getPortalContainer) {
	return {
		components: {
			MuiModal: {
				defaultProps: {
					container: getPortalContainer,
				},
			},
			MuiPopover: {
				defaultProps: {
					container: getPortalContainer,
				},
			},
			MuiPopper: {
				defaultProps: {
					container: getPortalContainer,
				},
			},
		},
	};
}
